module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="modal-error">\n	<div class="modal-error-container">\n		<a class="modal-error-close js-close">\n			<i class="ion-android-close"></i>\n		</a>\n		<div class="modal-error-inner">\n			<header class="modal-error-header">Error!</header>\n			<div class="modal-error-body">\n				';
 _.each(errors, function(error){ 
__p+='\n					<p>'+
((__t=( error ))==null?'':_.escape(__t))+
'</p>\n				';
 }) 
__p+='\n				<div class="modal-error-btn">\n					<button class="btn js-close">Yep, got it!</button>\n				</div>\n			</div>\n		</div>\n	</div>\n</div>';
}
return __p;
};
